module.exports = __webpack_public_path__ + "img/equipment.d9fb90c4.svg";